import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Header = styled.header`
  display: flex;
  margin-bottom: 32px;
`;

export const Body = styled.div``;

export const Footer = styled.footer`
  margin-top: 64px;
  text-align: center;
`;

export const FooterProgress = styled.div`
  max-width: 175px;
  margin: 0 auto;
`;

export const FooterAction = styled.div`
  margin-top: 24px;
`;
